import { Voucher } from '@lib/types/api/adapters/Voucher';
import { RedeemVoucherFormContent } from '@lib/types/cms/RedeemVoucherForm';
import { LinkButton } from '@ui-components/index';
import Image from 'next/image';
import { interpolateStringWithData } from 'utils';

export const RedeemedVoucherSuccess = ({
  content,
  voucher,
}: {
  content: Pick<
    RedeemVoucherFormContent,
    'successMessage' | 'claimButtonLabel'
  >;
  voucher: Voucher;
}) => {
  const {
    successMessage: { heading, paragraph },
  } = content;
  return (
    <div className="flex flex-col items-start justify-start gap-5">
      <h2 className="header-mid leading-8 md:leading-9">
        {interpolateStringWithData(heading ?? '', {
          packageName: voucher.packageName,
        })}
      </h2>
      <p>
        {interpolateStringWithData(paragraph ?? '', {
          durationEnd: voucher.durationEnd,
        })}
      </p>
      <div className="flex w-full flex-col items-center gap-8 md:items-start">
        <div className="inline-flex w-80 flex-col overflow-hidden rounded-lg shadow-[0px_6px_20px_2px_rgba(0,0,0,0.16)] md:w-72">
          <div className="inline-flex flex-col items-start justify-start gap-3 self-stretch rounded-lg bg-white pb-3">
            <div className="relative h-48 self-stretch">
              <Image
                className="absolute left-0 top-0 h-fit w-fit object-cover"
                src={voucher.packageImageUrl}
                alt={voucher.packageName}
                width={288}
                height={192}
              />
            </div>
            <div className="z-10 flex flex-col items-start justify-start gap-0.5 self-stretch px-3">
              <h3 className="text-sm text-grey-600">{voucher.publisherName}</h3>
              <p className="body-small">[{voucher.packageName}]</p>
            </div>
          </div>
        </div>
        <LinkButton
          href={voucher.checkoutUrl}
          openLinkInNewTab={false}
          label={content?.claimButtonLabel ?? 'Claim now'}
          className="min-w-80 text-center md:min-w-[218px]"
          style="primary"
          size="medium"
        />
      </div>
    </div>
  );
};
